import { callExternalApi, CallResult } from '../callExternalApi';

export interface CreateTaskPayload {
  outside_inventory_id: string;
}

export interface Task {
  id: string;
  sfId?: string;
  status?: string;
  sourceId?: string;
  sourceType?: string;
  type?: string;
}

export async function getTasks(accountIds: string[]): Promise<CallResult<Task[]>> {
  if (!accountIds?.length) return { data: null, error: { message: 'Must provide account ID to fetch tasks' } };
  return await callExternalApi<Task[]>({
    url: `api/tasks?account_ids=${accountIds.join(',')}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
}

export async function postTask(payload: CreateTaskPayload): Promise<CallResult<Task>> {
  return await callExternalApi<Task>({
    url: 'api/tasks',
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: payload
  });
}

export interface ContactAdvisorPayload {
  contact_reason: 'cost_intelligence';
  comment?: string;
}

export async function contactAdvisor(payload: ContactAdvisorPayload): Promise<CallResult<Task[]>> {
  return await callExternalApi<Task[]>({
    url: 'api/tasks/contact',
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: payload
  });
}
